<template>
    <div class="flex border-t border-b -mb-px border-gray-200 bg-white"
         v-if="(!item.omitted) || showOmitted ">
        <div class="w-6 flex-shrink-0 self-start py-1.5">
            <div class="w-5 h-5 flex items-center">
            </div>
        </div>
        <!-- Reference. -->
        <div class="w-16 flex">
            <page-cell
                ref="reference"
                :read-only="true"
                class="text-sm px-2 py-1.5 border-l border-r border-gray-200"
                :class="item.omitted?'text-red-600 line-through':'text-gray-900'"
                v-model="item.reference"
            ></page-cell>
        </div>
        <div class="flex flex-1">
            <div class="flex flex-col flex-1">
                <div class="flex flex-1">
                    <!-- Description. -->
                    <div class="flex-1 flex-col relative -my-px bg-white" :key="showItemProgress?0:1" :class="'flex'">
                        <div
                            ref="description"
                            class="whitespace-pre-line text-sm w-full -ml-px my-0 mb-0 px-2 py-1.5 border border-gray-200 shadow-none relative resize-none min-h-[34px]"
                            :class="(item.omitted?'text-red-600 line-through':'text-gray-900')+(!opened?' max-h-[34px] overflow-hidden leading-8 pt-0':'')"
                            v-text="item.description"
                        ></div>
                        <div class="absolute right-2 top-0 z-20">
                            <div
                                class="inline-block text-xs text-gray-200 m-0 align-top pt-2 opacity-25 hover:opacity-100"
                                @click="toggleBuildup">
                                <svg xmlns="http://www.w3.org/2000/svg" class="opacity-60" width="14" height="14"
                                     viewBox="0 0 24 24">
                                    <path
                                        d="M9.916 8.195h-.013v.961c-.034 1.598 4.213 1.601 4.161 0v-.96c-.123-1.511-4.042-1.52-4.148-.001zm2.08.71c-.723 0-1.311-.253-1.311-.564 0-.312.588-.564 1.311-.564.724 0 1.311.253 1.311.564 0 .311-.587.564-1.311.564zm6.421-2.155v-.96c-.124-1.511-4.042-1.52-4.148-.001h-.013v.961c-.034 1.599 4.214 1.602 4.161 0zm-2.067-1.379c.723 0 1.311.253 1.311.564s-.589.565-1.311.565c-.724 0-1.311-.253-1.311-.564s.587-.565 1.311-.565zm-10.797.418h-.013v.961c-.034 1.598 4.213 1.601 4.161 0v-.96c-.123-1.511-4.042-1.519-4.148-.001zm2.08.711c-.723 0-1.311-.253-1.311-.564s.588-.565 1.311-.565c.724 0 1.311.253 1.311.564s-.588.565-1.311.565zm2.283-2.988l-.013.201v.759c-.034 1.598 4.214 1.602 4.161 0v-.959c-.124-1.512-4.042-1.52-4.148-.001zm3.392.145c0 .311-.588.564-1.311.564-.724 0-1.311-.253-1.311-.564s.587-.564 1.311-.564c.723 0 1.311.253 1.311.564zm-1.308-3.657l-11 6 .009.019-.009-.005v12.118l11 5.868 11-5.869v-12.055l-11-6.076zm-1 21l-8-4.268v-7.133l8 4.401v7zm-8.885-14.464l9.882-5.396 9.917 5.458-9.896 5.385-9.903-5.447zm10.885 7.464l8-4.353v7.085l-8 4.268v-7z"/>
                                </svg>
                            </div>
                            <div
                                class="inline-block text-xs text-gray-600 m-0 align-top pt-2.5 opacity-25 hover:opacity-100"
                                @click="toggleOpened">
                                <i class="fa fa-eye" :class="!canBeOpened?'opacity-0':''"></i>
                            </div>
                        </div>
                        <div class="w-full h-6 pb-0.5 -mt-px -mx-px relative border border-b border-gray-20 bg-white"
                             v-if="showItemProgress">
                            <contracted-works-progress-line :percent="percent"></contracted-works-progress-line>
                        </div>
                    </div>
                    <!-- Quantity. -->
                    <div class="w-28 -ml-px flex">
                        <page-cell
                            :read-only="true"
                            class="text-sm -ml-px -my-px px-2 py-1.5 border border-gray-200 bg-white"
                            :class="item.omitted?'text-red-600 line-through':'text-gray-900'"
                            placeholder="Qty"
                            v-model="item.quantity"
                        ></page-cell>
                    </div>
                </div>
                <div class="flex flex-1 border-t border-r border-gray-200 -ml-px -mt-px mb-0 mr-px p-2 bg-gray-50"
                     v-if="currentItem===item.id">
                    <cost-plan-components :item="item"
                                          :cost-plan="costPlan"
                                          @changed="$emit('updated')"
                                          :readonly="readonly || item.omitted"></cost-plan-components>
                </div>
            </div>
        </div>
        <!-- Dropdown. -->
        <div class="w-6 flex-shrink-0 ml-2 self-start py-1.5">
        </div>
    </div>
</template>

<script>

import CostPlanProgressLine from "./CostPlanProgressLine.vue";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiDropdown from "../../ui/UiDropdown.vue";
import CostPlanComponents from "./components/CostPlanComponents.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import ContractedWorksProgressLine from "../contracted-works/ContractedWorksProgressLine.vue";
import * as math from "mathjs";

export default {
    components: {
        ContractedWorksProgressLine,
        UiButtonNew,
        CostPlanComponents,
        UiDropdown,
        UiDropdownItem,
        UiDropdownDivider,
        CostPlanProgressLine
    },
    props: {
        costPlan: Object,
        section: Object,
        task: Object,
        item: Object,
        showItemProgress: Boolean,
        showOmitted: Boolean,
        currentItem: null,
        readonly: false,
        latestProgressReport: Object,
    },
    data() {
        let percent = '0%';
        if (this.latestProgressReport) {
            const os = this.latestProgressReport.sections.find((i) => i.id === this.section.id);
            const ot = (os ? os : {tasks: []}).tasks.find((i) => i.id === this.task.id);
            const oi = (ot ? ot : {items: []}).items.find((i) => i.id === this.item.id);
            percent = oi ? (math.round(parseFloat(oi.complete), 0) + '%') : '0%';
        }
        return {
            percent: percent,
            opened: true,
            preFocusOpen: false,
            canBeOpened: true,
        }
    },
    computed: {},
    methods: {
        toggleOpened() {
            this.opened = !this.opened;
        },
        toggleBuildup() {
            this.$emit('toggleBuildup', this.item)
        },
    },
    mounted() {
        this.opened = false;
        this.$nextTick(() => {
            this.canBeOpened = this.$refs.description ? (this.$refs.description.scrollHeight > this.$refs.description.getBoundingClientRect().height + 6) : false;
        })
    }
}
</script>
